export default __webpack_public_path__ + "static/media/QuestionLessonBG.5a2c90af.png";